<template>
  <div class="cursorPainter" ref="cursorPainter">
    <div id="cursor-pointer" ref="cursorPointer" class="cursor-pointer"></div>
    <div id="center-point" ref="centerPoint" class="center-point"></div>
  </div>
</template>

<script>
import bus from '@/assets/eventBus'
export default {
  data () {
    return {}
  },
  mounted () {
    bus.$on('cursorPosCursorPaint', (val) => {
      this.$refs.cursorPainter.style.opacity = '1'
      this.$refs.centerPoint.style.left = val[0] + 'px'
      this.$refs.centerPoint.style.top = val[1] + 'px'
      setTimeout(() => {
        this.$refs.cursorPointer.style.left = val[0] + 'px'
        this.$refs.cursorPointer.style.top = val[1] + 'px'
      }, 50)
    })
    bus.$on('cursorFocus', () => {
      this.$refs.cursorPointer.className = 'cursor-pointer-focus'
      this.$refs.centerPoint.className = 'center-point-focus'
    })
    bus.$on('cursorFocusRelease', () => {
      this.$refs.cursorPointer.className = 'cursor-pointer'
      this.$refs.centerPoint.className = 'center-point'
    })
  },
  methods: {}
}

</script>

<style scoped lang="scss">
.cursorPainter {
  opacity: 0;
  pointer-events: none;
  position: fixed;
  z-index: 901;
  bottom: 0;
  width: 100%;
  height: 100%;
  #cursor-pointer {
    width: 50px;
    height: 50px;
    margin-left: -25px;
    margin-top: -25px;
    left: -1000px;
    top: -1000px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 2px solid white;
    position: absolute;
    box-shadow: 0 0 3px black;
  }
  .cursor-pointer {
    background-color: rgba(255, 255, 255, 0);
    transform: scale(1);
    transition: background-color 0.3s, transform 0.3s;
  }
  .cursor-pointer-focus {
    background-color: rgba(255, 255, 255, 0.2);
    transform: scale(0.8);
    transition: background-color 0.3s, transform 0.3s;
  }
  #center-point {
    position: absolute;
    width: 4px;
    height: 4px;
    margin-top: -2px;
    margin-left: -2px;
    left: -1000px;
    top: -1000px;
    background-color: white;
    border-radius: 50%;
    box-shadow: 0 0 3px black;
  }
  .center-point {
    transform: scale(1);
    transition: transform 0.3s;
  }
  .center-point-focus {
    transform: scale(2);
    transition: transform 0.3s;
  }
}

</style>
